export default __webpack_public_path__ + "css/tax.bundle.css";